export const capitaliseFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function convertTemperatures(obj: any): string {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let result: string[] = [];

  for (let i = 1; i <= 12; i++) {
    const month = months[i - 1];
    const temperature = obj[i.toString() as keyof any];
    result.push(`${month}: ${temperature}°C`);
  }

  return result.join(", ");
}
